import { Component, Prop, Vue } from "vue-property-decorator";
import { VueScreenObject } from "vue-screen";

export enum StepList {
  asbestos = 1,
  settings = 2,
  equipment = 3,
  results = 4,
}
@Component
export default class StepperHeader extends Vue {
  $screen!: VueScreenObject;
  @Prop({ default: [] })
  public steps!: string[];

  @Prop({ default: StepList.asbestos })
  public currentStep!: StepList;
}
